/** «Не вошли в расчётки» (10.10.2026, владелец: «некоторых доп работ нет в расчётках» — Вероника, 02.10
 *  и 07.10: отчёт сдан, а в расчётке пусто). Над расчётками — что за период ждёт решения ОО:
 *  - заявки и возвраты оператору — в расчётку не входят совсем, пока их не принять;
 *  - время по отчёту, которое ОО не подтвердил, — входит по плану, а не по отчёту.
 *  «Проверить ›» открывает окно «Проверка допработ за период» на этот же период; после него
 *  зарплата пересчитывается (onChanged), и расчётки формируются уже с принятыми работами. */
import { useEffect, useState, type ReactElement } from "react";
import { api } from "../../api/client";
import type { ApiList } from "../../api/types";
import { toExtraWork, type ExtraWork, type RawEw } from "../../hooks/useExtraWork";
import { ExtraReview } from "./ExtraReview";
import css from "./board.module.css";

const dm = (iso: string): string => `${iso.slice(8, 10)}.${iso.slice(5, 7)}`;
const line = (w: ExtraWork): string => `${w.operatorName} ${dm(w.date)} ${w.timeFrom}–${w.timeTo}`;

export function PayslipPending({ period, onChanged }: { period: { from: string; to: string }; onChanged: () => void }): ReactElement | null {
  const [works, setWorks] = useState<ExtraWork[]>([]);
  const [open, setOpen] = useState(false);
  const [tick, setTick] = useState(0);
  const [dirty, setDirty] = useState(false);   // пересчитываем зарплату, только если в окне что-то сохранили
  useEffect(() => {
    let alive = true;
    api<ApiList<RawEw>>(`/api/extra-work?from=${period.from}&to=${period.to}`)
      .then((r) => { if (alive) setWorks((r.results ?? []).map(toExtraWork)); })
      .catch(() => { if (alive) setWorks([]); });
    return () => { alive = false; };
  }, [period.from, period.to, tick]);

  /* ДК/ОО зарплата не считает — в «не вошли в расчётки» их нет */
  const out = works.filter((w) => w.operatorPaid !== false && (w.status === "proposed" || w.status === "rework"));
  const byPlan = works.filter((w) => w.operatorPaid !== false && !["proposed", "rework", "rejected", "training"].includes(w.status) && w.kind !== "training"
    && !w.factOk && !!w.factFrom && !!w.factTo && (w.factFrom !== w.timeFrom || w.factTo !== w.timeTo));
  if (!out.length && !byPlan.length && !open) return null;
  return (
    <div className={css.psWarn} style={{ display: "grid", gap: 6, margin: "8px 0" }}>
      {out.length ? <div>Не вошли в расчётки — ждут решения ОО ({out.length}): {out.map(line).join(", ")}.</div> : null}
      {byPlan.length ? <div>По плану, а не по отчёту — время не подтверждено ({byPlan.length}): {byPlan.map((w) => `${line(w)} → по отчёту ${w.factFrom}–${w.factTo}`).join(", ")}.</div> : null}
      <button type="button" className={css.psBtn} style={{ justifySelf: "start", flex: "none", padding: "0 14px" }} onClick={() => setOpen(true)}>Проверить ›</button>
      {open ? <ExtraReview from={period.from} to={period.to} onChanged={() => setDirty(true)}
        onClose={() => { setOpen(false); if (dirty) { setDirty(false); setTick((n) => n + 1); onChanged(); } }} /> : null}
    </div>
  );
}
